module.exports = __webpack_public_path__ + "static/media/ci.abe37e2d.svg";